// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/slickgrid/dist/styles/css/slick.columnpicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/slickgrid/dist/styles/css/slick-alpine-theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=\"%23666\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex: 1;
  min-height: 0;
  position: relative;
}

.explorer-backdrop {
  display: none;
}

.explorer-panel {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}

/* ── Header ─────────────────────────────────────────── */

.explorer-header {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  padding: 10px 16px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  flex-shrink: 0;
  z-index: 10;
}

.explorer-header-top {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.explorer-title {
  font-size: 17px;
  font-weight: 700;
  color: #113E57;
  white-space: nowrap;
  flex-shrink: 0;
}

.source-crumb {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  background: #e8f4ff;
  border: 1px solid #c0ddf5;
  color: #1a5a8a;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s;
}

.source-crumb:hover {
  background: #d4eaff;
  border-color: #a0c8e8;
}

.source-crumb.hidden {
  display: none;
}

.source-crumb.source-crumb-empty {
  background: #fff3e0;
  border-color: #f0c890;
  color: #8a5a00;
}

.source-picker {
  position: relative;
  flex: 1;
  min-width: 0;
}

/* ── Source Picker Trigger ───────────────────────────── */

.source-picker-trigger {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 14px;
  border: 2px dashed #b8c6d4;
  border-radius: 6px;
  background: #f8fafc;
  color: #5a6a78;
  font-size: 13px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s, background 0.15s;
}

.source-picker-trigger:hover {
  border-color: #2e72b7;
  background: #f0f6ff;
  color: #2e72b7;
}

.source-picker-trigger.has-source {
  border-style: solid;
  border-color: #28a745;
  background: #f0faf3;
  color: #1e6f35;
  font-weight: 600;
}

.source-picker-trigger-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-source {
  font-size: 12px;
  color: #555;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  min-width: 0;
  flex: 0 1 auto;
}

.auto-defaults {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  margin-left: 4px;
  overflow: hidden;
  white-space: nowrap;
}

.auto-defaults.hidden {
  display: none;
}

.auto-defaults-label {
  font-size: 11px;
  color: #6f7780;
  flex-shrink: 0;
}

.auto-default-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef5fc;
  border: 1px solid #d5e6f8;
  color: #174d7e;
  font-size: 11px;
  font-weight: 600;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  appearance: none;
}

.auto-default-chip:hover {
  background: #e2eefb;
  border-color: #bdd8f3;
}

/* badges */
.badge {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  margin-left: 3px;
  vertical-align: middle;
  letter-spacing: 0.3px;
}

.badge-type     { background: #e8f0fe; color: #1a73e8; }
.badge-compound { background: #fce8b2; color: #b06000; }
.badge-format   { background: #e6f4ea; color: #1e8e3e; }

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}

@media (max-width: 1080px) {
  .explorer-header-top {
    flex-wrap: wrap;
    row-gap: 8px;
  }

  .auto-defaults {
    order: 2;
    flex: 1 1 100%;
    max-width: 100%;
    margin-left: 0;
  }

  .header-actions {
    order: 3;
    margin-left: 0;
  }
}

.btn {
  padding: 7px 14px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  font-weight: 600;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.btn-primary            { background: #2e72b7; color: #fff; }
.btn-primary:hover:not(:disabled) { background: #1a5fa0; }

.btn-secondary          { background: #f1f3f4; color: #333; }
.btn-secondary:hover:not(:disabled) { background: #e2e6ea; }

.btn-icon               { background: transparent; color: #666; font-size: 16px; padding: 5px 10px; border-radius: 4px; }
.btn-icon:hover         { background: #f0f0f0; color: #222; }

/* ── Body ────────────────────────────────────────────── */

.explorer-body {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

/* ── Sidebar ─────────────────────────────────────────── */

.explorer-sidebar {
  width: 280px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  border-right: 1px solid #e0e0e0;
  background: #fafafa;
}

.explorer-sidebar.hidden {
  display: none;
}

.sidebar-section {
  padding: 10px 12px;
  border-bottom: 1px solid #e8e8e8;
  flex-shrink: 0;
}

.sidebar-section.hidden {
  display: none;
}

.section-title {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #999;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-actions {
  display: flex;
  align-items: center;
  gap: 2px;
}

.section-actions-sep {
  color: #ccc;
  font-size: 10px;
}

.link-btn {
  background: transparent;
  border: none;
  color: #2e72b7;
  font-size: 11px;
  cursor: pointer;
  padding: 0 3px;
  font-weight: 600;
}

.link-btn:hover {
  text-decoration: underline;
}

.link-btn.is-active {
  color: #0b4e7a;
  background: #e4f0fb;
  border-radius: 999px;
  padding: 1px 7px;
  text-decoration: none;
}

.link-btn.is-active:hover {
  text-decoration: none;
}

/* ── Field list ──────────────────────────────────────── */

.field-search-input {
  width: 100%;
  box-sizing: border-box;
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 12px;
  margin-bottom: 6px;
  outline: none;
}

.field-search-input:focus {
  border-color: #2e72b7;
}

.field-list {
  max-height: 300px;
  overflow-y: auto;
}

.field-group {
  margin-bottom: 6px;
}

.field-group-label {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  color: #bbb;
  padding: 3px 0 1px;
  letter-spacing: 0.5px;
}

.field-item {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  box-sizing: border-box;
  padding: 5px 8px;
  background: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  color: #333;
  text-align: left;
  font-family: inherit;
  white-space: nowrap;
  overflow: hidden;
  transition: background 0.15s, border-color 0.15s;
  margin-bottom: 2px;
}

.field-item:hover {
  background: #f0f4f8;
  border-color: #aac4d8;
}

.field-item.selected {
  background: #dfeeff;
  border-color: #6aaad8;
  color: #0b4e7a;
  font-weight: 600;
}

.field-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.field-name.is-key {
  font-weight: 700;
  color: #1a5fa0;
}

.field-item.selected .field-name.is-key {
  color: #063a5c;
}

.field-type {
  font-size: 10px;
  color: #bbb;
  flex-shrink: 0;
}

.field-item.selected .field-type {
  color: #5a8bb0;
}

/* ── Filters ─────────────────────────────────────────── */

.filter-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-row {
  display: flex;
  gap: 3px;
  align-items: center;
}

.filter-field,
.filter-op {
  font-size: 11px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 3px 4px;
  background: #fff;
  min-width: 0;
}

.filter-field { flex: 2; }
.filter-op    { flex: 1.5; }

.filter-value {
  flex: 2;
  min-width: 0;
  font-size: 11px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 3px 4px;
}

.filter-remove {
  flex-shrink: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #bbb;
  font-size: 13px;
  padding: 2px 4px;
  line-height: 1;
}

.filter-remove:hover {
  color: #c00;
}

.filter-pick-btn {
  flex-shrink: 0;
  border: 1px solid #d3d9e1;
  background: #f7f9fc;
  color: #2c5d8a;
  font-size: 10px;
  border-radius: 3px;
  padding: 3px 6px;
  cursor: pointer;
}

.filter-pick-btn:hover {
  background: #edf3ff;
  border-color: #b8cdeb;
}

/* ── Aggregation ─────────────────────────────────────── */

.aggr-controls {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.aggr-controls select {
  font-size: 12px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 4px 6px;
  background: #fff;
}

.aggr-controls select.hidden {
  display: none;
}

/* ── Time range ──────────────────────────────────────── */

.time-label {
  display: block;
  font-size: 10px;
  color: #aaa;
  margin-bottom: 2px;
  margin-top: 5px;
}

.time-input {
  width: 100%;
  box-sizing: border-box;
  font-size: 11px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 3px 5px;
}

.time-preset-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.time-preset-btn,
.time-scope-btn {
  padding: 6px 12px;
  font-size: 12px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  background: #fff;
  color: #344054;
  cursor: pointer;
  transition: all 0.15s;
}

.time-preset-btn:hover,
.time-scope-btn:hover {
  background: #f0f6ff;
  border-color: #4a90d9;
}

.time-preset-btn.active,
.time-scope-btn.active {
  background: #e8f0fe;
  border-color: #4a90d9;
  color: #1a56db;
  font-weight: 600;
}

.time-custom-details {
  margin-top: 12px;
}

.time-custom-summary {
  font-size: 12px;
  color: #667;
  cursor: pointer;
  user-select: none;
  padding: 4px 0;
}

.time-custom-summary:hover {
  color: #4a90d9;
}

.time-custom-body {
  padding: 8px 0;
}

/* ── Results panel ───────────────────────────────────── */

.explorer-results {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.results-bar {
  flex-shrink: 0;
  padding: 5px 12px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  min-height: 28px;
}

.controls-launchers {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.control-launch-btn {
  border: 1px solid #d2d8de;
  background: #fff;
  color: #3c5568;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.control-launch-btn:hover:not(:disabled) {
  background: #f1f6fb;
  border-color: #c2cfdb;
}

.control-launch-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.results-count {
  font-weight: 700;
  color: #333;
  white-space: nowrap;
}

.status-bar {
  color: #777;
  white-space: nowrap;
}

.results-view-toggle {
  display: inline-flex;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.toggle-btn {
  padding: 3px 10px;
  font-size: 11px;
  border: none;
  background: #fff;
  color: #555;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.15s, color 0.15s;
}

.toggle-btn + .toggle-btn {
  border-left: 1px solid #d0d0d0;
}

.toggle-btn.active {
  background: #1976d2;
  color: #fff;
}

.toggle-btn:hover:not(.active) {
  background: #f0f0f0;
}

.query-display {
  font-size: 10px;
  color: #aaa;
  font-family: monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

.table-target {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

#table-target .explorer-cell-truncate {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.table-target.hidden {
  display: none;
}

.chart-preview-target {
  flex: 1;
  min-height: 300px;
  overflow: hidden;
}

.chart-preview-target.hidden {
  display: none;
}

.metric-preview-target {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
}

.metric-preview-target.hidden {
  display: none;
}

.metric-preview-card {
  text-align: center;
  padding: 30px 40px;
  background: #fff;
  border: 1px solid #dde4eb;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  min-width: 200px;
}

.metric-preview-value {
  font-size: 48px;
  font-weight: 700;
  color: #113E57;
  line-height: 1.1;
}

.metric-preview-title {
  font-size: 14px;
  font-weight: 600;
  color: #5a6a78;
  margin-top: 8px;
}

.metric-preview-suffix {
  font-size: 12px;
  color: #8a9aaa;
  margin-top: 4px;
}

.json-target {
  flex: 1;
  min-height: 0;
  overflow: auto;
  background: #0f1720;
  border-top: 1px solid #1d2a36;
}

.json-target.hidden {
  display: none;
}

.schema-target {
  flex: 1;
  min-height: 0;
  overflow: auto;
  background: #f8fafc;
  border-top: 1px solid #d9e2ec;
  display: flex;
  flex-direction: column;
}

.schema-target.hidden {
  display: none;
}

.config-target {
  flex: 1;
  overflow: auto;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.config-target.hidden { display: none; }
.config-toolbar {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
  padding: 6px 10px;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
}
.config-output {
  flex: 1;
  margin: 0;
  padding: 12px 14px;
  font-size: 11px;
  line-height: 1.5;
  background: #f8f9fa;
  white-space: pre-wrap;
  word-break: break-word;
  overflow: auto;
}

.json-copy-btn.hidden {
  display: none;
}

.schema-toolbar {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid #d9e2ec;
  background: #f2f7fb;
}

.schema-view-toggle {
  display: inline-flex;
  border: 1px solid #c7d5e2;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.schema-copy-btn {
  padding: 5px 10px;
  font-size: 11px;
}

.schema-summary-content {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.schema-summary-content.hidden {
  display: none;
}

.schema-section {
  background: #fff;
  border: 1px solid #d7e0e8;
  border-radius: 6px;
  padding: 10px;
}

.schema-section-title {
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 700;
  color: #1b3e5c;
}

.schema-meta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 8px;
}

.schema-meta-item {
  font-size: 11px;
  color: #324c61;
  background: #f7fbff;
  border: 1px solid #e0eaf2;
  border-radius: 4px;
  padding: 6px 8px;
}

.schema-meta-item .k {
  color: #5a7388;
  margin-right: 6px;
}

.schema-pill-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.schema-pill {
  border: 1px solid #c9dced;
  background: #ecf5ff;
  color: #1f5278;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
}

.schema-op-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 8px;
}

.schema-op-card {
  border: 1px solid #deebf7;
  background: #f8fcff;
  border-radius: 4px;
  padding: 8px;
  font-size: 11px;
  color: #2d4b63;
}

.schema-op-card .op-title {
  font-weight: 700;
  color: #214868;
  margin-bottom: 4px;
}

.schema-fields-table-wrap {
  overflow: auto;
}

.schema-fields-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}

.schema-fields-table th,
.schema-fields-table td {
  border: 1px solid #dde6ee;
  padding: 5px 6px;
  text-align: left;
  vertical-align: top;
}

.schema-fields-table th {
  position: sticky;
  top: 0;
  background: #eff5fb;
  z-index: 1;
  color: #38556c;
  font-weight: 700;
}

.schema-json-content {
  flex: 1;
  min-height: 0;
  overflow: auto;
  background: #0f1720;
  border-top: 1px solid #1d2a36;
}

.schema-json-content.hidden {
  display: none;
}

.json-pretty {
  margin: 0;
  padding: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
  line-height: 1.45;
  color: #d8e5f3;
  white-space: pre;
  tab-size: 2;
}

.json-key {
  color: #7dc8ff;
}

.json-string {
  color: #a2e28f;
}

.json-number {
  color: #f7c477;
}

.json-boolean {
  color: #d9a7ff;
  font-weight: 600;
}

.json-null {
  color: #ff9ca2;
  font-weight: 600;
}

/* ── Granularity selector ───────────────────────────── */

.granularity-control {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 8px;
}

.granularity-control.hidden {
  display: none;
}

.granularity-select {
  font-size: 12px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 4px 6px;
  background: #fff;
}

/* ── Adornments ─────────────────────────────────────── */

.adornment-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.adornment-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  font-size: 11px;
  padding: 4px 0;
}

.adornment-order {
  font-size: 11px;
  font-weight: 700;
  color: #8a9aaa;
  min-width: 16px;
  flex-shrink: 0;
}

/* Loading spinner */
.source-loading-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  font-size: 12px;
  color: #6b7a8a;
}
.source-loading-indicator.hidden { display: none; }
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #e0e0e0;
  border-top-color: #4a90d9;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

.adornment-source,
.adornment-key {
  font-size: 11px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 3px 4px 3px 4px;
  padding-right: 24px;
  background: #fff;
  min-width: 80px;
  max-width: 140px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 4px center;
  background-size: 16px 16px;
  cursor: pointer;
}

.adornment-source-btn {
  font-size: 11px;
  border: 1px dashed #b8c6d4;
  border-radius: 3px;
  padding: 4px 8px;
  background: #f8fafc;
  color: #5a6a78;
  cursor: pointer;
  text-align: left;
  max-width: 100%;
  min-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.adornment-source-btn:hover {
  border-color: #2e72b7;
  background: #f0f6ff;
  color: #2e72b7;
}

.adornment-source-btn.has-source {
  border-style: solid;
  border-color: #28a745;
  background: #f0faf3;
  color: #1e6f35;
  font-weight: 600;
}

.adornment-key-mapping {
  display: none; /* inline key mapping replaced by modal */
}

.adornment-key-row {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
}

.adornment-key-label {
  font-weight: 600;
  color: #3a5a7a;
  min-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.adornment-key-arrow {
  color: #aaa;
  font-size: 12px;
  flex-shrink: 0;
}

.adornment-key-field {
  flex: 1;
  min-width: 80px;
  font-size: 11px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 2px 4px;
  background: #fff;
}

.adornment-key-status {
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.adornment-no-keys {
  font-size: 10px;
  color: #c57600;
  font-style: italic;
}

/* ── Key Mapping Modal ───────────────────────────────── */

.adorn-key-mapping-body {
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.adorn-key-mapping-hint {
  font-size: 12px;
  color: #5a6a78;
  line-height: 1.5;
}

.adorn-key-mapping-rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.adorn-key-map-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #f8fafc;
  border: 1px solid #e0e6ed;
  border-radius: 6px;
}

.adorn-key-map-adorn-side {
  flex: 0 0 auto;
  min-width: 140px;
  font-size: 13px;
  font-weight: 600;
  color: #1a3a5c;
}

.adorn-key-map-adorn-side .key-badge {
  display: inline-block;
  font-size: 9px;
  font-weight: 700;
  color: #fff;
  background: #5a7a96;
  padding: 1px 5px;
  border-radius: 3px;
  margin-left: 6px;
  vertical-align: middle;
}

.adorn-key-map-arrow {
  font-size: 18px;
  color: #aab8c8;
  flex-shrink: 0;
}

.adorn-key-map-primary-side {
  flex: 1;
  min-width: 0;
}

.adorn-key-map-primary-side select {
  width: 100%;
  font-size: 13px;
  padding: 6px 10px;
  border: 1px solid #c0cad4;
  border-radius: 4px;
  background: #fff;
}

.adorn-key-map-primary-side select.mapped {
  border-color: #28a745;
  background: #f0faf3;
}

.adorn-key-map-primary-side select.unmapped {
  border-color: #c57600;
  background: #fef8f0;
}

/* ── Join-only Fields ────────────────────────────────── */

.section-hint {
  font-size: 10px;
  color: #8a9aaa;
  font-weight: 400;
  margin-left: 6px;
}

.join-fields-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.join-field-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  font-size: 11px;
  border-radius: 4px;
  background: #fef8f0;
  border: 1px solid #eed9b8;
}

.join-field-row.excluded {
  background: #f5f7f8;
  border-color: #e0e0e0;
  text-decoration: line-through;
  color: #aaa;
}

.join-field-name {
  flex: 1;
  font-weight: 600;
  color: #5a4a2a;
}

.join-field-row.excluded .join-field-name {
  color: #aaa;
}

.join-field-reason {
  font-size: 10px;
  color: #8a7a5a;
}

.join-field-toggle {
  font-size: 10px;
  cursor: pointer;
  border: 1px solid #c0cad4;
  border-radius: 3px;
  padding: 2px 8px;
  background: #fff;
}

.adornment-fields-display {
  font-size: 10px;
  color: #999;
  white-space: nowrap;
  flex-shrink: 0;
}

.adornment-remove {
  background: none;
  border: none;
  color: #ccc;
  font-size: 16px;
  cursor: pointer;
  padding: 0 2px;
  line-height: 1;
}

.adornment-remove:hover {
  color: #d9534f;
}

.provider-picker-modal {
  position: absolute;
  inset: 0;
  z-index: 3000;
}

.provider-picker-modal.hidden {
  display: none;
}

.provider-picker-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(16, 24, 38, 0.45);
}

.provider-picker-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(560px, calc(100vw - 40px));
  max-height: calc(100vh - 80px);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.22);
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.provider-picker-title {
  font-size: 15px;
  font-weight: 700;
  color: #113e57;
}

.provider-picker-subtitle {
  font-size: 11px;
  color: #7a8590;
}

.provider-picker-select {
  width: 100%;
  min-height: 260px;
  border: 1px solid #d8dee6;
  border-radius: 6px;
  padding: 6px;
  font-size: 12px;
  box-sizing: border-box;
}

.provider-picker-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.controls-modal-dialog {
  width: min(920px, calc(100vw - 36px));
  max-height: calc(100vh - 48px);
}

.controls-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.controls-modal-close {
  padding: 3px 9px;
}

.controls-modal-content {
  min-height: 280px;
  max-height: calc(100vh - 170px);
  overflow: auto;
  border: 1px solid #e1e8ee;
  border-radius: 8px;
  background: #f9fbfd;
  padding: 0;
}

.controls-modal-content .sidebar-section {
  border-bottom: 1px solid #e2e8ef;
  background: #fdfefe;
}

.controls-modal-content .sidebar-section:last-child {
  border-bottom: none;
}

.adorn-shortcut-menu {
  position: fixed;
  z-index: 3500;
  min-width: 320px;
  max-width: 460px;
  max-height: 360px;
  overflow: auto;
  background: #fff;
  border: 1px solid #d7dde6;
  border-radius: 8px;
  box-shadow: 0 14px 36px rgba(17, 24, 39, 0.22);
  padding: 6px;
}

.adorn-shortcut-menu.hidden {
  display: none;
}

.adorn-shortcut-title {
  font-size: 11px;
  font-weight: 700;
  color: #4d5967;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 6px 8px;
}

.adorn-shortcut-item {
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
}

.adorn-shortcut-item:hover {
  background: #edf3ff;
}

.adorn-shortcut-item-path {
  font-size: 12px;
  font-weight: 600;
  color: #223242;
}

.adorn-shortcut-item-meta {
  font-size: 10px;
  color: #768394;
  margin-top: 2px;
}

.adorn-shortcut-empty {
  font-size: 12px;
  color: #7b8795;
  padding: 8px;
}

#table-target .slick-header-column.explorer-header-active {
  outline: 2px solid #2e72b7;
  outline-offset: -2px;
  border-radius: 4px;
}

/* ── Step Navigation ─────────────────────────────────── */

.step-nav {
  display: flex;
  align-items: stretch;
  gap: 0;
  border-top: 1px solid #e0e0e0;
  background: #f8fafb;
  overflow-x: auto;
}

.step-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 12px;
  border: none;
  border-bottom: 3px solid transparent;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #6b7c8a;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s, background 0.15s;
}

.step-tab:hover:not(:disabled) {
  color: #2e72b7;
  background: #f0f6ff;
}

.step-tab.active {
  color: #1a5fa0;
  border-bottom-color: #2e72b7;
  background: #fff;
}

.step-tab.completed {
  color: #1e7e34;
}

.step-tab:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #e2e8ed;
  color: #5a6a77;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
}

.step-tab.active .step-num {
  background: #2e72b7;
  color: #fff;
}

.step-tab.completed .step-num {
  background: #28a745;
  color: #fff;
}

/* ── Step Panels ─────────────────────────────────────── */

.step-panels {
  width: 380px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  border-right: 1px solid #e0e0e0;
  background: #fafbfc;
  transition: width 0.2s ease, opacity 0.2s ease;
}

.step-panels.collapsed {
  width: 0;
  overflow: hidden;
  border-right: none;
  opacity: 0;
  pointer-events: none;
}

.step-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.step-panel.hidden {
  display: none;
}

.step-panel-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

/* ── Step Instruction Banner ─────────────────────────── */

.step-instruction {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #1a3a5c;
  background: linear-gradient(to right, #e8f1fb, #f4f8fd);
  border-bottom: 1px solid #d0dce8;
  line-height: 1.4;
}

.step-hint {
  font-size: 11px;
  color: #7a8a96;
  font-style: italic;
  padding: 8px 12px;
  background: #f0f4f7;
  border-radius: 4px;
  margin-top: 10px;
}

.step-hint.hidden {
  display: none;
}

.step-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-top: 1px solid #e8e8e8;
  background: #fff;
  flex-shrink: 0;
}

.step-next-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* ── Builder Sections ────────────────────────────────── */

.builder-section {
  margin-bottom: 16px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #e8edf2;
  border-radius: 6px;
}
.builder-section.hidden { display: none; }

/* ── Viz Suggestion Hint ─────────────────────────────── */

.viz-suggestion {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  margin-bottom: 10px;
  background: var(--surface-alt, #edf6ff);
  border: 1px solid var(--accent-muted, #b3d4fc);
  border-radius: 6px;
  font-size: 12px;
  color: var(--text-secondary, #3a5a7a);
}

.viz-suggestion .link-btn { font-size: 12px; }

/* ── Visualization Type Grid ─────────────────────────── */

.viz-type-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.viz-type-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 14px 10px;
  border: 2px solid #e0e6ec;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.viz-type-btn:hover {
  border-color: #b3cfe6;
  background: #f5f9ff;
}

.viz-type-btn.active {
  border-color: #2e72b7;
  background: #edf4ff;
}

.viz-type-icon {
  font-size: 22px;
  color: #4a6b84;
}

.viz-type-btn.active .viz-type-icon {
  color: #1a5fa0;
}

.viz-type-label {
  font-size: 11px;
  font-weight: 600;
  color: #445c6e;
}

.viz-type-btn.active .viz-type-label {
  color: #1a5fa0;
}

/* ── Axis Controls ───────────────────────────────────── */

.axis-controls {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.axis-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.axis-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #7a8a96;
}

.axis-select,
.axis-input {
  width: 100%;
  box-sizing: border-box;
  font-size: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 6px 8px;
  background: #fff;
}

.axis-select[multiple] {
  min-height: 80px;
}

/* ── Customize Controls ──────────────────────────────── */

.customize-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.customize-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.customize-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #7a8a96;
}

.customize-input,
.customize-select {
  width: 100%;
  box-sizing: border-box;
  font-size: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 6px 8px;
  background: #fff;
}

/* ── Output Config ───────────────────────────────────── */

.output-config {
  margin: 0;
  padding: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  line-height: 1.45;
  background: #0f1720;
  color: #d8e5f3;
  border-radius: 6px;
  overflow: auto;
  max-height: 400px;
  white-space: pre;
  tab-size: 2;
}

/* ── GroupBy ─────────────────────────────────────────── */

.groupby-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.groupby-row {
  display: flex;
  gap: 4px;
  align-items: center;
}

.groupby-field {
  flex: 1;
  font-size: 11px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 3px 6px;
  background: #fff;
}

.groupby-remove {
  flex-shrink: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #bbb;
  font-size: 13px;
  padding: 2px 4px;
  line-height: 1;
}

.groupby-remove:hover {
  color: #c00;
}

/* ── Column Config ───────────────────────────────────── */

.col-config-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 280px;
  overflow-y: auto;
}

.col-config-row {
  display: grid;
  grid-template-columns: 1fr 1fr 80px;
  gap: 4px;
  align-items: center;
  padding: 4px 6px;
  background: #f7f9fb;
  border: 1px solid #e8ecf0;
  border-radius: 4px;
  font-size: 11px;
}

.col-config-field-name {
  font-weight: 600;
  color: #334;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.col-config-label {
  font-size: 10px;
  color: #7a8a96;
}

.col-config-row select,
.col-config-row input {
  font-size: 11px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 2px 4px;
  background: #fff;
  min-width: 0;
}

.col-config-row input[type="text"] {
  width: 100%;
  box-sizing: border-box;
}

/* ── Responsive ──────────────────────────────────────── */

@media (max-width: 900px) {
  .step-panels {
    width: 100%;
    max-height: 45vh;
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
  }

  .explorer-body {
    flex-direction: column;
  }

  .step-tab {
    padding: 8px 8px;
    font-size: 11px;
  }

  .step-tab .step-num {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/explorer.css"],"names":[],"mappings":"AAIA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,0DAA0D;;AAE1D;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;;AAEvD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,0BAA0B,mBAAmB,EAAE,WAAW,EAAE;AAC5D,oCAAoC,mBAAmB,EAAE;;AAEzD,0BAA0B,mBAAmB,EAAE,WAAW,EAAE;AAC5D,sCAAsC,mBAAmB,EAAE;;AAE3D,0BAA0B,uBAAuB,EAAE,WAAW,EAAE,eAAe,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACxH,0BAA0B,mBAAmB,EAAE,WAAW,EAAE;;AAE5D,2DAA2D;;AAE3D;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,2DAA2D;;AAE3D;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2DAA2D;;AAE3D;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA,gBAAgB,OAAO,EAAE;AACzB,gBAAgB,SAAS,EAAE;;AAE3B;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,2DAA2D;;AAE3D;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2DAA2D;;AAE3D;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,cAAc;EACd,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA,wBAAwB,aAAa,EAAE;AACvC;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,OAAO;EACP,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,aAAa;EACb,+GAA+G;EAC/G,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0DAA0D;;AAE1D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0DAA0D;;AAE1D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA,mCAAmC,aAAa,EAAE;AAClD;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD;;EAEE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yDAAkL;EAClL,4BAA4B;EAC5B,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,yCAAyC;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,2DAA2D;;AAE3D;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,2DAA2D;;AAE3D;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,qCAAqC;EACrC,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,oBAAoB;EACpB,MAAM;EACN,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,2DAA2D;;AAE3D;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,2DAA2D;;AAE3D;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uDAAuD;EACvD,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,2DAA2D;;AAE3D;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA,0BAA0B,aAAa,EAAE;;AAEzC,2DAA2D;;AAE3D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA,4BAA4B,eAAe,EAAE;;AAE7C,2DAA2D;;AAE3D;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2DAA2D;;AAE3D;EACE,SAAS;EACT,aAAa;EACb,6EAA6E;EAC7E,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,2DAA2D;;AAE3D;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["@import url(\"~slickgrid/dist/styles/css/slick.columnpicker.css\");\n@import url(\"~slickgrid/dist/styles/css/slick-alpine-theme.css\");\n@import url(\"./global.css\");\n\n:host {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  position: relative;\n}\n\n.explorer-backdrop {\n  display: none;\n}\n\n.explorer-panel {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n}\n\n/* ── Header ─────────────────────────────────────────── */\n\n.explorer-header {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 6px;\n  padding: 10px 16px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  flex-shrink: 0;\n  z-index: 10;\n}\n\n.explorer-header-top {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.explorer-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: #113E57;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.source-crumb {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 999px;\n  background: #e8f4ff;\n  border: 1px solid #c0ddf5;\n  color: #1a5a8a;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  max-width: 400px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.source-crumb:hover {\n  background: #d4eaff;\n  border-color: #a0c8e8;\n}\n\n.source-crumb.hidden {\n  display: none;\n}\n\n.source-crumb.source-crumb-empty {\n  background: #fff3e0;\n  border-color: #f0c890;\n  color: #8a5a00;\n}\n\n.source-picker {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n\n/* ── Source Picker Trigger ───────────────────────────── */\n\n.source-picker-trigger {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 10px 14px;\n  border: 2px dashed #b8c6d4;\n  border-radius: 6px;\n  background: #f8fafc;\n  color: #5a6a78;\n  font-size: 13px;\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.source-picker-trigger:hover {\n  border-color: #2e72b7;\n  background: #f0f6ff;\n  color: #2e72b7;\n}\n\n.source-picker-trigger.has-source {\n  border-style: solid;\n  border-color: #28a745;\n  background: #f0faf3;\n  color: #1e6f35;\n  font-weight: 600;\n}\n\n.source-picker-trigger-text {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.selected-source {\n  font-size: 12px;\n  color: #555;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n  min-width: 0;\n  flex: 0 1 auto;\n}\n\n.auto-defaults {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  margin-left: 4px;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.auto-defaults.hidden {\n  display: none;\n}\n\n.auto-defaults-label {\n  font-size: 11px;\n  color: #6f7780;\n  flex-shrink: 0;\n}\n\n.auto-default-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #eef5fc;\n  border: 1px solid #d5e6f8;\n  color: #174d7e;\n  font-size: 11px;\n  font-weight: 600;\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  appearance: none;\n}\n\n.auto-default-chip:hover {\n  background: #e2eefb;\n  border-color: #bdd8f3;\n}\n\n/* badges */\n.badge {\n  display: inline-block;\n  padding: 1px 7px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  margin-left: 3px;\n  vertical-align: middle;\n  letter-spacing: 0.3px;\n}\n\n.badge-type     { background: #e8f0fe; color: #1a73e8; }\n.badge-compound { background: #fce8b2; color: #b06000; }\n.badge-format   { background: #e6f4ea; color: #1e8e3e; }\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n@media (max-width: 1080px) {\n  .explorer-header-top {\n    flex-wrap: wrap;\n    row-gap: 8px;\n  }\n\n  .auto-defaults {\n    order: 2;\n    flex: 1 1 100%;\n    max-width: 100%;\n    margin-left: 0;\n  }\n\n  .header-actions {\n    order: 3;\n    margin-left: 0;\n  }\n}\n\n.btn {\n  padding: 7px 14px;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  cursor: pointer;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.btn-primary            { background: #2e72b7; color: #fff; }\n.btn-primary:hover:not(:disabled) { background: #1a5fa0; }\n\n.btn-secondary          { background: #f1f3f4; color: #333; }\n.btn-secondary:hover:not(:disabled) { background: #e2e6ea; }\n\n.btn-icon               { background: transparent; color: #666; font-size: 16px; padding: 5px 10px; border-radius: 4px; }\n.btn-icon:hover         { background: #f0f0f0; color: #222; }\n\n/* ── Body ────────────────────────────────────────────── */\n\n.explorer-body {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* ── Sidebar ─────────────────────────────────────────── */\n\n.explorer-sidebar {\n  width: 280px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  border-right: 1px solid #e0e0e0;\n  background: #fafafa;\n}\n\n.explorer-sidebar.hidden {\n  display: none;\n}\n\n.sidebar-section {\n  padding: 10px 12px;\n  border-bottom: 1px solid #e8e8e8;\n  flex-shrink: 0;\n}\n\n.sidebar-section.hidden {\n  display: none;\n}\n\n.section-title {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: #999;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.section-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.section-actions-sep {\n  color: #ccc;\n  font-size: 10px;\n}\n\n.link-btn {\n  background: transparent;\n  border: none;\n  color: #2e72b7;\n  font-size: 11px;\n  cursor: pointer;\n  padding: 0 3px;\n  font-weight: 600;\n}\n\n.link-btn:hover {\n  text-decoration: underline;\n}\n\n.link-btn.is-active {\n  color: #0b4e7a;\n  background: #e4f0fb;\n  border-radius: 999px;\n  padding: 1px 7px;\n  text-decoration: none;\n}\n\n.link-btn.is-active:hover {\n  text-decoration: none;\n}\n\n/* ── Field list ──────────────────────────────────────── */\n\n.field-search-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 4px 8px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-size: 12px;\n  margin-bottom: 6px;\n  outline: none;\n}\n\n.field-search-input:focus {\n  border-color: #2e72b7;\n}\n\n.field-list {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.field-group {\n  margin-bottom: 6px;\n}\n\n.field-group-label {\n  font-size: 9px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #bbb;\n  padding: 3px 0 1px;\n  letter-spacing: 0.5px;\n}\n\n.field-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 5px 8px;\n  background: #fff;\n  border: 1px solid #d0d0d0;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #333;\n  text-align: left;\n  font-family: inherit;\n  white-space: nowrap;\n  overflow: hidden;\n  transition: background 0.15s, border-color 0.15s;\n  margin-bottom: 2px;\n}\n\n.field-item:hover {\n  background: #f0f4f8;\n  border-color: #aac4d8;\n}\n\n.field-item.selected {\n  background: #dfeeff;\n  border-color: #6aaad8;\n  color: #0b4e7a;\n  font-weight: 600;\n}\n\n.field-name {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.field-name.is-key {\n  font-weight: 700;\n  color: #1a5fa0;\n}\n\n.field-item.selected .field-name.is-key {\n  color: #063a5c;\n}\n\n.field-type {\n  font-size: 10px;\n  color: #bbb;\n  flex-shrink: 0;\n}\n\n.field-item.selected .field-type {\n  color: #5a8bb0;\n}\n\n/* ── Filters ─────────────────────────────────────────── */\n\n.filter-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.filter-row {\n  display: flex;\n  gap: 3px;\n  align-items: center;\n}\n\n.filter-field,\n.filter-op {\n  font-size: 11px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px 4px;\n  background: #fff;\n  min-width: 0;\n}\n\n.filter-field { flex: 2; }\n.filter-op    { flex: 1.5; }\n\n.filter-value {\n  flex: 2;\n  min-width: 0;\n  font-size: 11px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px 4px;\n}\n\n.filter-remove {\n  flex-shrink: 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #bbb;\n  font-size: 13px;\n  padding: 2px 4px;\n  line-height: 1;\n}\n\n.filter-remove:hover {\n  color: #c00;\n}\n\n.filter-pick-btn {\n  flex-shrink: 0;\n  border: 1px solid #d3d9e1;\n  background: #f7f9fc;\n  color: #2c5d8a;\n  font-size: 10px;\n  border-radius: 3px;\n  padding: 3px 6px;\n  cursor: pointer;\n}\n\n.filter-pick-btn:hover {\n  background: #edf3ff;\n  border-color: #b8cdeb;\n}\n\n/* ── Aggregation ─────────────────────────────────────── */\n\n.aggr-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.aggr-controls select {\n  font-size: 12px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 4px 6px;\n  background: #fff;\n}\n\n.aggr-controls select.hidden {\n  display: none;\n}\n\n/* ── Time range ──────────────────────────────────────── */\n\n.time-label {\n  display: block;\n  font-size: 10px;\n  color: #aaa;\n  margin-bottom: 2px;\n  margin-top: 5px;\n}\n\n.time-input {\n  width: 100%;\n  box-sizing: border-box;\n  font-size: 11px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px 5px;\n}\n\n.time-preset-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.time-preset-btn,\n.time-scope-btn {\n  padding: 6px 12px;\n  font-size: 12px;\n  border: 1px solid #d0d5dd;\n  border-radius: 6px;\n  background: #fff;\n  color: #344054;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.time-preset-btn:hover,\n.time-scope-btn:hover {\n  background: #f0f6ff;\n  border-color: #4a90d9;\n}\n\n.time-preset-btn.active,\n.time-scope-btn.active {\n  background: #e8f0fe;\n  border-color: #4a90d9;\n  color: #1a56db;\n  font-weight: 600;\n}\n\n.time-custom-details {\n  margin-top: 12px;\n}\n\n.time-custom-summary {\n  font-size: 12px;\n  color: #667;\n  cursor: pointer;\n  user-select: none;\n  padding: 4px 0;\n}\n\n.time-custom-summary:hover {\n  color: #4a90d9;\n}\n\n.time-custom-body {\n  padding: 8px 0;\n}\n\n/* ── Results panel ───────────────────────────────────── */\n\n.explorer-results {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.results-bar {\n  flex-shrink: 0;\n  padding: 5px 12px;\n  background: #f5f5f5;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 12px;\n  min-height: 28px;\n}\n\n.controls-launchers {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.control-launch-btn {\n  border: 1px solid #d2d8de;\n  background: #fff;\n  color: #3c5568;\n  border-radius: 4px;\n  padding: 3px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.control-launch-btn:hover:not(:disabled) {\n  background: #f1f6fb;\n  border-color: #c2cfdb;\n}\n\n.control-launch-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.results-count {\n  font-weight: 700;\n  color: #333;\n  white-space: nowrap;\n}\n\n.status-bar {\n  color: #777;\n  white-space: nowrap;\n}\n\n.results-view-toggle {\n  display: inline-flex;\n  border: 1px solid #d0d0d0;\n  border-radius: 4px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.toggle-btn {\n  padding: 3px 10px;\n  font-size: 11px;\n  border: none;\n  background: #fff;\n  color: #555;\n  cursor: pointer;\n  font-weight: 600;\n  transition: background 0.15s, color 0.15s;\n}\n\n.toggle-btn + .toggle-btn {\n  border-left: 1px solid #d0d0d0;\n}\n\n.toggle-btn.active {\n  background: #1976d2;\n  color: #fff;\n}\n\n.toggle-btn:hover:not(.active) {\n  background: #f0f0f0;\n}\n\n.query-display {\n  font-size: 10px;\n  color: #aaa;\n  font-family: monospace;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 0;\n}\n\n.table-target {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n#table-target .explorer-cell-truncate {\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.table-target.hidden {\n  display: none;\n}\n\n.chart-preview-target {\n  flex: 1;\n  min-height: 300px;\n  overflow: hidden;\n}\n\n.chart-preview-target.hidden {\n  display: none;\n}\n\n.metric-preview-target {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8fafc;\n}\n\n.metric-preview-target.hidden {\n  display: none;\n}\n\n.metric-preview-card {\n  text-align: center;\n  padding: 30px 40px;\n  background: #fff;\n  border: 1px solid #dde4eb;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n  min-width: 200px;\n}\n\n.metric-preview-value {\n  font-size: 48px;\n  font-weight: 700;\n  color: #113E57;\n  line-height: 1.1;\n}\n\n.metric-preview-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #5a6a78;\n  margin-top: 8px;\n}\n\n.metric-preview-suffix {\n  font-size: 12px;\n  color: #8a9aaa;\n  margin-top: 4px;\n}\n\n.json-target {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  background: #0f1720;\n  border-top: 1px solid #1d2a36;\n}\n\n.json-target.hidden {\n  display: none;\n}\n\n.schema-target {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  background: #f8fafc;\n  border-top: 1px solid #d9e2ec;\n  display: flex;\n  flex-direction: column;\n}\n\n.schema-target.hidden {\n  display: none;\n}\n\n.config-target {\n  flex: 1;\n  overflow: auto;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n.config-target.hidden { display: none; }\n.config-toolbar {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: flex-end;\n  padding: 6px 10px;\n  background: #fafafa;\n  border-bottom: 1px solid #e8e8e8;\n}\n.config-output {\n  flex: 1;\n  margin: 0;\n  padding: 12px 14px;\n  font-size: 11px;\n  line-height: 1.5;\n  background: #f8f9fa;\n  white-space: pre-wrap;\n  word-break: break-word;\n  overflow: auto;\n}\n\n.json-copy-btn.hidden {\n  display: none;\n}\n\n.schema-toolbar {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border-bottom: 1px solid #d9e2ec;\n  background: #f2f7fb;\n}\n\n.schema-view-toggle {\n  display: inline-flex;\n  border: 1px solid #c7d5e2;\n  border-radius: 4px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.schema-copy-btn {\n  padding: 5px 10px;\n  font-size: 11px;\n}\n\n.schema-summary-content {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.schema-summary-content.hidden {\n  display: none;\n}\n\n.schema-section {\n  background: #fff;\n  border: 1px solid #d7e0e8;\n  border-radius: 6px;\n  padding: 10px;\n}\n\n.schema-section-title {\n  margin: 0 0 8px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #1b3e5c;\n}\n\n.schema-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 8px;\n}\n\n.schema-meta-item {\n  font-size: 11px;\n  color: #324c61;\n  background: #f7fbff;\n  border: 1px solid #e0eaf2;\n  border-radius: 4px;\n  padding: 6px 8px;\n}\n\n.schema-meta-item .k {\n  color: #5a7388;\n  margin-right: 6px;\n}\n\n.schema-pill-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.schema-pill {\n  border: 1px solid #c9dced;\n  background: #ecf5ff;\n  color: #1f5278;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 3px 8px;\n}\n\n.schema-op-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));\n  gap: 8px;\n}\n\n.schema-op-card {\n  border: 1px solid #deebf7;\n  background: #f8fcff;\n  border-radius: 4px;\n  padding: 8px;\n  font-size: 11px;\n  color: #2d4b63;\n}\n\n.schema-op-card .op-title {\n  font-weight: 700;\n  color: #214868;\n  margin-bottom: 4px;\n}\n\n.schema-fields-table-wrap {\n  overflow: auto;\n}\n\n.schema-fields-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 11px;\n}\n\n.schema-fields-table th,\n.schema-fields-table td {\n  border: 1px solid #dde6ee;\n  padding: 5px 6px;\n  text-align: left;\n  vertical-align: top;\n}\n\n.schema-fields-table th {\n  position: sticky;\n  top: 0;\n  background: #eff5fb;\n  z-index: 1;\n  color: #38556c;\n  font-weight: 700;\n}\n\n.schema-json-content {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  background: #0f1720;\n  border-top: 1px solid #1d2a36;\n}\n\n.schema-json-content.hidden {\n  display: none;\n}\n\n.json-pretty {\n  margin: 0;\n  padding: 12px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #d8e5f3;\n  white-space: pre;\n  tab-size: 2;\n}\n\n.json-key {\n  color: #7dc8ff;\n}\n\n.json-string {\n  color: #a2e28f;\n}\n\n.json-number {\n  color: #f7c477;\n}\n\n.json-boolean {\n  color: #d9a7ff;\n  font-weight: 600;\n}\n\n.json-null {\n  color: #ff9ca2;\n  font-weight: 600;\n}\n\n/* ── Granularity selector ───────────────────────────── */\n\n.granularity-control {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-bottom: 8px;\n}\n\n.granularity-control.hidden {\n  display: none;\n}\n\n.granularity-select {\n  font-size: 12px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 4px 6px;\n  background: #fff;\n}\n\n/* ── Adornments ─────────────────────────────────────── */\n\n.adornment-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.adornment-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n  font-size: 11px;\n  padding: 4px 0;\n}\n\n.adornment-order {\n  font-size: 11px;\n  font-weight: 700;\n  color: #8a9aaa;\n  min-width: 16px;\n  flex-shrink: 0;\n}\n\n/* Loading spinner */\n.source-loading-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 0;\n  font-size: 12px;\n  color: #6b7a8a;\n}\n.source-loading-indicator.hidden { display: none; }\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e0e0e0;\n  border-top-color: #4a90d9;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.adornment-source,\n.adornment-key {\n  font-size: 11px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px 4px 3px 4px;\n  padding-right: 24px;\n  background: #fff;\n  min-width: 80px;\n  max-width: 140px;\n  appearance: none;\n  background-image: url('data:image/svg+xml;utf8,<svg fill=\"%23666\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: right 4px center;\n  background-size: 16px 16px;\n  cursor: pointer;\n}\n\n.adornment-source-btn {\n  font-size: 11px;\n  border: 1px dashed #b8c6d4;\n  border-radius: 3px;\n  padding: 4px 8px;\n  background: #f8fafc;\n  color: #5a6a78;\n  cursor: pointer;\n  text-align: left;\n  max-width: 100%;\n  min-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n}\n\n.adornment-source-btn:hover {\n  border-color: #2e72b7;\n  background: #f0f6ff;\n  color: #2e72b7;\n}\n\n.adornment-source-btn.has-source {\n  border-style: solid;\n  border-color: #28a745;\n  background: #f0faf3;\n  color: #1e6f35;\n  font-weight: 600;\n}\n\n.adornment-key-mapping {\n  display: none; /* inline key mapping replaced by modal */\n}\n\n.adornment-key-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n}\n\n.adornment-key-label {\n  font-weight: 600;\n  color: #3a5a7a;\n  min-width: 70px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.adornment-key-arrow {\n  color: #aaa;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.adornment-key-field {\n  flex: 1;\n  min-width: 80px;\n  font-size: 11px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 2px 4px;\n  background: #fff;\n}\n\n.adornment-key-status {\n  font-size: 10px;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.adornment-no-keys {\n  font-size: 10px;\n  color: #c57600;\n  font-style: italic;\n}\n\n/* ── Key Mapping Modal ───────────────────────────────── */\n\n.adorn-key-mapping-body {\n  padding: 14px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.adorn-key-mapping-hint {\n  font-size: 12px;\n  color: #5a6a78;\n  line-height: 1.5;\n}\n\n.adorn-key-mapping-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.adorn-key-map-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background: #f8fafc;\n  border: 1px solid #e0e6ed;\n  border-radius: 6px;\n}\n\n.adorn-key-map-adorn-side {\n  flex: 0 0 auto;\n  min-width: 140px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a3a5c;\n}\n\n.adorn-key-map-adorn-side .key-badge {\n  display: inline-block;\n  font-size: 9px;\n  font-weight: 700;\n  color: #fff;\n  background: #5a7a96;\n  padding: 1px 5px;\n  border-radius: 3px;\n  margin-left: 6px;\n  vertical-align: middle;\n}\n\n.adorn-key-map-arrow {\n  font-size: 18px;\n  color: #aab8c8;\n  flex-shrink: 0;\n}\n\n.adorn-key-map-primary-side {\n  flex: 1;\n  min-width: 0;\n}\n\n.adorn-key-map-primary-side select {\n  width: 100%;\n  font-size: 13px;\n  padding: 6px 10px;\n  border: 1px solid #c0cad4;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.adorn-key-map-primary-side select.mapped {\n  border-color: #28a745;\n  background: #f0faf3;\n}\n\n.adorn-key-map-primary-side select.unmapped {\n  border-color: #c57600;\n  background: #fef8f0;\n}\n\n/* ── Join-only Fields ────────────────────────────────── */\n\n.section-hint {\n  font-size: 10px;\n  color: #8a9aaa;\n  font-weight: 400;\n  margin-left: 6px;\n}\n\n.join-fields-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.join-field-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  font-size: 11px;\n  border-radius: 4px;\n  background: #fef8f0;\n  border: 1px solid #eed9b8;\n}\n\n.join-field-row.excluded {\n  background: #f5f7f8;\n  border-color: #e0e0e0;\n  text-decoration: line-through;\n  color: #aaa;\n}\n\n.join-field-name {\n  flex: 1;\n  font-weight: 600;\n  color: #5a4a2a;\n}\n\n.join-field-row.excluded .join-field-name {\n  color: #aaa;\n}\n\n.join-field-reason {\n  font-size: 10px;\n  color: #8a7a5a;\n}\n\n.join-field-toggle {\n  font-size: 10px;\n  cursor: pointer;\n  border: 1px solid #c0cad4;\n  border-radius: 3px;\n  padding: 2px 8px;\n  background: #fff;\n}\n\n.adornment-fields-display {\n  font-size: 10px;\n  color: #999;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.adornment-remove {\n  background: none;\n  border: none;\n  color: #ccc;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 0 2px;\n  line-height: 1;\n}\n\n.adornment-remove:hover {\n  color: #d9534f;\n}\n\n.provider-picker-modal {\n  position: absolute;\n  inset: 0;\n  z-index: 3000;\n}\n\n.provider-picker-modal.hidden {\n  display: none;\n}\n\n.provider-picker-backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(16, 24, 38, 0.45);\n}\n\n.provider-picker-dialog {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(560px, calc(100vw - 40px));\n  max-height: calc(100vh - 80px);\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.22);\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.provider-picker-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #113e57;\n}\n\n.provider-picker-subtitle {\n  font-size: 11px;\n  color: #7a8590;\n}\n\n.provider-picker-select {\n  width: 100%;\n  min-height: 260px;\n  border: 1px solid #d8dee6;\n  border-radius: 6px;\n  padding: 6px;\n  font-size: 12px;\n  box-sizing: border-box;\n}\n\n.provider-picker-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.controls-modal-dialog {\n  width: min(920px, calc(100vw - 36px));\n  max-height: calc(100vh - 48px);\n}\n\n.controls-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.controls-modal-close {\n  padding: 3px 9px;\n}\n\n.controls-modal-content {\n  min-height: 280px;\n  max-height: calc(100vh - 170px);\n  overflow: auto;\n  border: 1px solid #e1e8ee;\n  border-radius: 8px;\n  background: #f9fbfd;\n  padding: 0;\n}\n\n.controls-modal-content .sidebar-section {\n  border-bottom: 1px solid #e2e8ef;\n  background: #fdfefe;\n}\n\n.controls-modal-content .sidebar-section:last-child {\n  border-bottom: none;\n}\n\n.adorn-shortcut-menu {\n  position: fixed;\n  z-index: 3500;\n  min-width: 320px;\n  max-width: 460px;\n  max-height: 360px;\n  overflow: auto;\n  background: #fff;\n  border: 1px solid #d7dde6;\n  border-radius: 8px;\n  box-shadow: 0 14px 36px rgba(17, 24, 39, 0.22);\n  padding: 6px;\n}\n\n.adorn-shortcut-menu.hidden {\n  display: none;\n}\n\n.adorn-shortcut-title {\n  font-size: 11px;\n  font-weight: 700;\n  color: #4d5967;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  padding: 6px 8px;\n}\n\n.adorn-shortcut-item {\n  width: 100%;\n  text-align: left;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  padding: 8px;\n  cursor: pointer;\n}\n\n.adorn-shortcut-item:hover {\n  background: #edf3ff;\n}\n\n.adorn-shortcut-item-path {\n  font-size: 12px;\n  font-weight: 600;\n  color: #223242;\n}\n\n.adorn-shortcut-item-meta {\n  font-size: 10px;\n  color: #768394;\n  margin-top: 2px;\n}\n\n.adorn-shortcut-empty {\n  font-size: 12px;\n  color: #7b8795;\n  padding: 8px;\n}\n\n#table-target .slick-header-column.explorer-header-active {\n  outline: 2px solid #2e72b7;\n  outline-offset: -2px;\n  border-radius: 4px;\n}\n\n/* ── Step Navigation ─────────────────────────────────── */\n\n.step-nav {\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n  border-top: 1px solid #e0e0e0;\n  background: #f8fafb;\n  overflow-x: auto;\n}\n\n.step-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 9px 12px;\n  border: none;\n  border-bottom: 3px solid transparent;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7c8a;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color 0.15s, border-color 0.15s, background 0.15s;\n}\n\n.step-tab:hover:not(:disabled) {\n  color: #2e72b7;\n  background: #f0f6ff;\n}\n\n.step-tab.active {\n  color: #1a5fa0;\n  border-bottom-color: #2e72b7;\n  background: #fff;\n}\n\n.step-tab.completed {\n  color: #1e7e34;\n}\n\n.step-tab:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.step-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #e2e8ed;\n  color: #5a6a77;\n  font-size: 10px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.step-tab.active .step-num {\n  background: #2e72b7;\n  color: #fff;\n}\n\n.step-tab.completed .step-num {\n  background: #28a745;\n  color: #fff;\n}\n\n/* ── Step Panels ─────────────────────────────────────── */\n\n.step-panels {\n  width: 380px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  border-right: 1px solid #e0e0e0;\n  background: #fafbfc;\n  transition: width 0.2s ease, opacity 0.2s ease;\n}\n\n.step-panels.collapsed {\n  width: 0;\n  overflow: hidden;\n  border-right: none;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.step-panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.step-panel.hidden {\n  display: none;\n}\n\n.step-panel-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n}\n\n/* ── Step Instruction Banner ─────────────────────────── */\n\n.step-instruction {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a3a5c;\n  background: linear-gradient(to right, #e8f1fb, #f4f8fd);\n  border-bottom: 1px solid #d0dce8;\n  line-height: 1.4;\n}\n\n.step-hint {\n  font-size: 11px;\n  color: #7a8a96;\n  font-style: italic;\n  padding: 8px 12px;\n  background: #f0f4f7;\n  border-radius: 4px;\n  margin-top: 10px;\n}\n\n.step-hint.hidden {\n  display: none;\n}\n\n.step-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  border-top: 1px solid #e8e8e8;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.step-next-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* ── Builder Sections ────────────────────────────────── */\n\n.builder-section {\n  margin-bottom: 16px;\n  padding: 10px 12px;\n  background: #fff;\n  border: 1px solid #e8edf2;\n  border-radius: 6px;\n}\n.builder-section.hidden { display: none; }\n\n/* ── Viz Suggestion Hint ─────────────────────────────── */\n\n.viz-suggestion {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  margin-bottom: 10px;\n  background: var(--surface-alt, #edf6ff);\n  border: 1px solid var(--accent-muted, #b3d4fc);\n  border-radius: 6px;\n  font-size: 12px;\n  color: var(--text-secondary, #3a5a7a);\n}\n\n.viz-suggestion .link-btn { font-size: 12px; }\n\n/* ── Visualization Type Grid ─────────────────────────── */\n\n.viz-type-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n}\n\n.viz-type-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 14px 10px;\n  border: 2px solid #e0e6ec;\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.viz-type-btn:hover {\n  border-color: #b3cfe6;\n  background: #f5f9ff;\n}\n\n.viz-type-btn.active {\n  border-color: #2e72b7;\n  background: #edf4ff;\n}\n\n.viz-type-icon {\n  font-size: 22px;\n  color: #4a6b84;\n}\n\n.viz-type-btn.active .viz-type-icon {\n  color: #1a5fa0;\n}\n\n.viz-type-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #445c6e;\n}\n\n.viz-type-btn.active .viz-type-label {\n  color: #1a5fa0;\n}\n\n/* ── Axis Controls ───────────────────────────────────── */\n\n.axis-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.axis-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.axis-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #7a8a96;\n}\n\n.axis-select,\n.axis-input {\n  width: 100%;\n  box-sizing: border-box;\n  font-size: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 6px 8px;\n  background: #fff;\n}\n\n.axis-select[multiple] {\n  min-height: 80px;\n}\n\n/* ── Customize Controls ──────────────────────────────── */\n\n.customize-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.customize-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.customize-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #7a8a96;\n}\n\n.customize-input,\n.customize-select {\n  width: 100%;\n  box-sizing: border-box;\n  font-size: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 6px 8px;\n  background: #fff;\n}\n\n/* ── Output Config ───────────────────────────────────── */\n\n.output-config {\n  margin: 0;\n  padding: 12px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n  line-height: 1.45;\n  background: #0f1720;\n  color: #d8e5f3;\n  border-radius: 6px;\n  overflow: auto;\n  max-height: 400px;\n  white-space: pre;\n  tab-size: 2;\n}\n\n/* ── GroupBy ─────────────────────────────────────────── */\n\n.groupby-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.groupby-row {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.groupby-field {\n  flex: 1;\n  font-size: 11px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px 6px;\n  background: #fff;\n}\n\n.groupby-remove {\n  flex-shrink: 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #bbb;\n  font-size: 13px;\n  padding: 2px 4px;\n  line-height: 1;\n}\n\n.groupby-remove:hover {\n  color: #c00;\n}\n\n/* ── Column Config ───────────────────────────────────── */\n\n.col-config-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.col-config-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 80px;\n  gap: 4px;\n  align-items: center;\n  padding: 4px 6px;\n  background: #f7f9fb;\n  border: 1px solid #e8ecf0;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n.col-config-field-name {\n  font-weight: 600;\n  color: #334;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.col-config-label {\n  font-size: 10px;\n  color: #7a8a96;\n}\n\n.col-config-row select,\n.col-config-row input {\n  font-size: 11px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 2px 4px;\n  background: #fff;\n  min-width: 0;\n}\n\n.col-config-row input[type=\"text\"] {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* ── Responsive ──────────────────────────────────────── */\n\n@media (max-width: 900px) {\n  .step-panels {\n    width: 100%;\n    max-height: 45vh;\n    border-right: none;\n    border-bottom: 1px solid #e0e0e0;\n  }\n\n  .explorer-body {\n    flex-direction: column;\n  }\n\n  .step-tab {\n    padding: 8px 8px;\n    font-size: 11px;\n  }\n\n  .step-tab .step-num {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
